import { useFormMutation } from "@/hooks/useFormMutation";
import { fetcher, sendData } from "@/services/api/fetcher";
import { ApiResponse, DataObject, DataPaginate } from "@/types";
import { useMutation, useQuery } from "@tanstack/react-query";
import { AgencyResponse } from "./interface";
import { AgencyFormPayload } from "./validation";

// get
const getAgency = async (
  query?: string
): Promise<ApiResponse<DataPaginate<AgencyResponse>>> => {
  return await fetcher(query ? `master/institution?${query}` : `master/fraksi`);
};

export const useGetAgency = (query?: string) => {
  return useQuery({
    queryKey: ["useGetAgency", query],
    queryFn: () => getAgency(query),
    refetchIntervalInBackground: true,
  });
};

// get by id
export const getAgencyById = async (
  id: number
): Promise<ApiResponse<DataObject<AgencyResponse>>> => {
  return await fetcher(`master/institution/${id}`);
};

export const useGetAgencyById = (id: number) => {
  return useQuery<ApiResponse<DataObject<AgencyResponse>>, Error>(
    ["useGetAgencyById", id],
    () => getAgencyById(id)
  );
};

// post
export const useAgency = (method: "POST" | "PUT" = "POST", id?: number) => {
  return useFormMutation<
    ApiResponse<DataObject<AgencyFormPayload>>,
    Error,
    AgencyFormPayload
  >({
    mutationFn: async (
      data
    ): Promise<ApiResponse<DataObject<AgencyFormPayload>>> => {
      const endpoint = id ? `master/institution/${id}` : "master/institution";
      const delay = new Promise((resolve) => setTimeout(resolve, 2000));
      const response: ApiResponse<DataObject<AgencyFormPayload>> =
        await sendData(endpoint, data, method);
      await delay;
      return response;
    },
    loadingMessage:
      method === "POST" ? "Menyimpan data..." : "Memperbarui data...",
    successMessage:
      method === "POST"
        ? "Data berhasil ditambahkan"
        : "Data berhasil diperbarui",
  });
};

export const useAgencyOption = () => {
  return useMutation<
    ApiResponse<DataObject<AgencyFormPayload>>,
    Error,
    AgencyFormPayload
  >({
    mutationFn: async (
      data
    ): Promise<ApiResponse<DataObject<AgencyFormPayload>>> => {
      const response: ApiResponse<DataObject<AgencyFormPayload>> =
        await sendData("master/institution", data, "POST");
      return response;
    },
  });
};
